import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ChatService } from '../../shared/chat/chat.service';

@Component({
  selector: 'app-chat-view',
  templateUrl: './chat-view.component.html',
  styleUrls: ['./chat-view.component.scss'],
})
export class ChatViewComponent implements OnInit {

  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  disableInputAndSendButton: boolean = false;
  @Input() selectedUser: any;
  currentUser: string = '';
  targetUser: string | null = null;
  targetEmail: any;
  status: string | null = null;
  conversationId: string = '';
  message: string = '';
  messages: { sender: string, content: string, date: any }[] = [];
  showCreateConversationButton: boolean = false;
  currentTime: any;
  user: any;
  @Output() reloadChatList = new EventEmitter<void>();
  constructor(private chatService: ChatService) { }
  ngOnInit() {
    this.currentUser = localStorage.getItem('sub') || '';
  }
  ngOnChanges() {
    if(this.selectedUser !== undefined && this.selectedUser !== null)
    {
    this.startChatWithUser(this.selectedUser);
    }
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      if(this.scrollContainer && this.scrollContainer.nativeElement) {
        this.scrollContainer.nativeElement.scrollTop = this.scrollContainer?.nativeElement?.scrollHeight;
      }
    } catch (err) {
      console.error('Scroll error', err);
    }
  }

  async sendMessage() {
    this.disableInputAndSendButton = true;
    if (this.message?.trim() !== '' && this.conversationId) {
      try {
        if (this.chatService && typeof this.chatService.sendMessage === 'function') {
          await this.chatService.sendMessage(this.conversationId, this.message);

          this.currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          this.messages.push({ sender: this.currentUser, content: this.message, date: this.currentTime });
          this.user.lastMessage = this.message;
          this.user.lastMessageTime = new Date();
          // const formattedDateTime = new Date().toISOString(); 
          // this.user.lastMessageTime = formattedDateTime;
          this.message = '';
          await this.updateTimeAndLastMessageInChatList(this.user);
          this.reloadChatList.emit();
         
          this.resetTextareaHeight();
          this.disableInputAndSendButton = false
        } else {
          console.error("chatService or sendMessage function is not available");
        }
      } catch (error) {
        console.error("Error sending message:", error);
      }
    } else {
      console.warn("Message is empty or conversationId is undefined");
    }
  }

  resetTextareaHeight(): void {
    const textarea = document.querySelector('.message-input') as HTMLTextAreaElement;
    if (textarea) {
      textarea.style.height = 'auto';
    }
  }



  async startChatWithUser(target: any) {
    this.user = target;

    this.targetUser = target?.name;
    this.status = target?.status;
    this.targetEmail = target?.email;
    const token = await this.chatService.getAccessToken(localStorage.getItem('sub'));
    await this.chatService.initializeClient(token);

    if (target?.sid !== null) {
      this.showCreateConversationButton = false;
      this.chatService.getChatConversationId(target?.sid).subscribe((data: any) => {
        if (data) {
          this.messages = [];
          this.conversationId = data.sid;
          this.loadMessages();
        }

      });
    }
    else {
      this.messages = [];
      this.showCreateConversationButton = true;
    }



    //This is required for realtime event for displaying message in target user window
    this.chatService.listenForMessages((message) => {
      if (message.author === this.targetEmail && !this.messages.some(msg => msg.content === message.body && msg.sender === message.author)) {
        this.messages.push({ sender: message.author, content: message.body, date: this.currentTime });
      }
    });
  }

  async loadMessages() {
    const conversation = await this.chatService.getConversationById(this.conversationId);
    const messages = await conversation?.getMessages();

    messages?.items.forEach(msg => {
      if (!this.messages.some(existingMsg => existingMsg.content === msg.body && existingMsg.sender === msg.author)) {
        const formattedTime = msg.dateCreated
          ? new Date(msg.dateCreated).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true, // Ensures 12-hour format with am/pm
          })
          : 'N/A'; // Fallback in case dateCreated is null or undefined

        this.messages.push({
          sender: msg.author || '',
          content: msg.body || '',
          date: formattedTime, // Use the formatted time or fallback
        });
      }
    });
  }


  CreateChatConversationPair() {
    this.chatService.CreateChatConverationPair(this.currentUser, this.targetEmail).subscribe();
  }

  updateTimeAndLastMessageInChatList(user: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.chatService.updateChatList(user).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  autoResize(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto'; // Reset the height
    textarea.style.height = `${textarea.scrollHeight}px`; // Set to scroll height
  }


  formatDate(date: any) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }



}

